import { render, staticRenderFns } from "./IndexTabs.vue?vue&type=template&id=15b5646e&scoped=true"
import script from "./IndexTabs.vue?vue&type=script&lang=js"
export * from "./IndexTabs.vue?vue&type=script&lang=js"
import style0 from "./IndexTabs.vue?vue&type=style&index=0&id=15b5646e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b5646e",
  null
  
)

export default component.exports